'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.fields');
    };
  };
};

exports.default = createGetFormMeta;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormMeta.js
// module id = 1148
// module chunks = 0